import { GetOrganizationDto } from './getOrganizationDto.interface';

export type UpdateOrganizationDto = GetOrganizationDto;
